import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { planResource, planContrast, planMarkResource, addMainPlan, budgetDetail, planArea } from './../request';
import topTitle from '@/components/title';
import PlanModel from './planModel.vue';
import comparisonModel from './comparisonModel.vue';
import budgetModel from './budgetModel.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  props: ['id', 'info'],
  components: {
    topTitle,
    PlanModel,
    comparisonModel,
    budgetModel
  },
  data() {
    return {
      durationType: [{
        id: 1,
        name: '年'
      }, {
        id: 2,
        name: '年'
      }, {
        id: 3,
        name: '天'
      }, {
        id: 4,
        name: '天'
      }, {
        id: 5,
        name: '终身'
      }],
      palnShow: false,
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: false,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        },
        onChange: (page, pageSize) => {}
      },
      columns: [{
        slots: {
          title: '方案编码'
        },
        dataIndex: 'mark',
        key: 'mark',
        align: 'center',
        scopedSlots: {
          customRender: 'mark'
        }
      }, {
        slots: {
          title: '方案名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        scopedSlots: {
          customRender: 'name'
        }
      }, {
        slots: {
          title: '方案代码'
        },
        dataIndex: 'code',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'code'
        }
      }, {
        slots: {
          title: '保障金额'
        },
        dataIndex: 'amount',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '保障期限'
        },
        dataIndex: 'duration',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'duration'
        }
      },
      // {title: '保障年龄', dataIndex: 'age', key: '4', align: 'center'},
      {
        slots: {
          title: '保费'
        },
        dataIndex: 'price',
        key: '5',
        align: 'center',
        scopedSlots: {
          customRender: 'price'
        }
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 100
      },
      // {title: '更新时间', dataIndex: 'updateAt', key: '7', align: 'center'},
      {
        slots: {
          title: '操作'
        },
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 250
      }],
      comparisonVisible: false,
      budgetVisible: false,
      comparisonList: {},
      paramsList: [],
      budget: {},
      formParams: [],
      previewData: {},
      hasNewBudget: false,
      addStauts: false,
      editStauts: false,
      copyStauts: false,
      stateStatus: false,
      tagList: [],
      firstIsEdit: false,
      showTableData: [],
      deletePlanId: []
    };
  },
  async mounted() {
    await this.getDataFun();
    const res = await budgetDetail({
      insuranceId: this.id
    });
    this.budget = res;
    if (res.moneyInfo) {
      this.budget.moneyInfo = JSON.parse(res.moneyInfo);
    }
    if (res.type) {
      this.budget.type = res.type;
    }
    if (!this.data.find(i => i.isDefault === 1)) {
      this.resetBudget();
    } else {
      this.getDimensions();
    }
  },
  methods: {
    isComparison() {
      let arr = this.data.filter(i => i.status != 0);
      return arr.length ? true : false;
    },
    getDuration(text) {
      if (text) {
        let name = '';
        let _this = this;
        this.durationType.map(item => {
          if (text.type === item.id) {
            if (text.type == 1 || text.type == 3) {
              name = text.value + _this.$t(item.name);
            } else if (text.type == 2 || text.type == 4) {
              name = text.value.split(',')[0] + '-' + text.value.split(',')[1] + _this.$t(item.name);
            } else if (text.type == 5) {
              name = _this.$t('终身');
            } else {
              name = '-';
            }
          }
        });
        return name;
      }
    },
    getAreaPrice(record) {
      let name = '';
      if (record.areaPrice) {
        var _price$price, _price$price2;
        let _price = JSON.parse(record.areaPrice);
        name = ((_price$price = _price.price) === null || _price$price === void 0 ? void 0 : _price$price.split(',')[0]) + '-' + ((_price$price2 = _price.price) === null || _price$price2 === void 0 ? void 0 : _price$price2.split(',')[1]);
      }
      return name;
    },
    getSavePlan(info, i, continueAdd) {
      var _this$data;
      if (this.data.findIndex(item => item.name == info.name) > -1 && this.data.findIndex(item => item.name == info.name) != i) {
        return this.$message.warn(this.$t('方案名称不能重复'));
      }
      if (this.data.find(item => item.id === info.id)) {
        this.data.splice(i, 1, info);
        this.firstIsEdit = true;
      } else {
        this.data.unshift(info);
      }
      if (continueAdd) {
        this.$refs.planForm.resetForm();
        this.$message.success(this.$t('保存成功'));
      } else {
        this.handleOk();
      }
      if (this.firstIsEdit && this.data.find(i => i.isDefault)) {
        this.$info({
          title: this.$t('未配置默认方案，请完成配置后保存'),
          okText: this.$t('确定'),
          onOk() {
            return;
          }
          // onCancel() {
          //   _this.editStauts = true;
          // }
        });
      }
      (_this$data = this.data) === null || _this$data === void 0 || _this$data.map((item, i) => {
        this.data[i].isDefault = 0;
      });
      this.pagination.total = this.data.length;
      this.resetBudget();
    },
    async getDataFun() {
      const res = await planResource({
        insuranceId: this.id
      });
      this.pagination.total = res.length;
      this.data.push(...res);
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleAdd() {
      if (!this.addStauts && this.data.find(i => i.isDefault)) {
        let _this = this;
        this.$confirm({
          title: this.$t('新增数据将会清空保费试算的默认方案，需重新进行配置（未配置无法保存数据），是否继续操作') + '？',
          okText: this.$t('确定'),
          async onOk() {
            _this.palnShow = true;
            _this.$nextTick(() => {
              _this.$refs.planForm.init(null, _this.id);
            });
            _this.addStauts = true;
            return;
          },
          onCancel() {
            _this.addStauts = true;
          }
        });
      } else {
        this.palnShow = true;
        this.$nextTick(() => {
          this.$refs.planForm.init(null, this.id);
        });
      }
    },
    handleEdit(val, i) {
      if (!this.editStauts && this.data.find(i => i.isDefault)) {
        let _this = this;
        this.$confirm({
          title: _this.$t('编辑数据将会清空保费试算的默认方案，需重新进行配置（未配置无法保存数据），是否继续操作') + '？',
          okText: this.$t('确定'),
          async onOk() {
            _this.palnShow = true;
            _this.$nextTick(() => {
              _this.$refs.planForm.init(val, _this.id, i);
            });
            _this.editStauts = true;
            return;
          },
          onCancel() {
            _this.editStauts = true;
          }
        });
      } else {
        this.palnShow = true;
        this.$nextTick(() => {
          this.$refs.planForm.init(val, this.id, i);
        });
      }
    },
    onCopy(val, i, isCopy) {
      if (!this.copyStauts && this.data.find(i => i.isDefault)) {
        let _this = this;
        this.$confirm({
          title: this.$t('复制数据将会清空保费试算的默认方案，需重新进行配置（未配置无法保存数据），是否继续操作') + '？',
          okText: this.$t('确定'),
          async onOk() {
            _this.palnShow = true;
            _this.$nextTick(() => {
              _this.$refs.planForm.init(val, _this.id, i, isCopy);
            });
            _this.copyStauts = true;
            return;
          },
          onCancel() {
            _this.copyStauts = true;
          }
        });
      } else {
        this.palnShow = true;
        this.$nextTick(() => {
          this.$refs.planForm.init(val, this.id, i, isCopy);
        });
      }
    },
    handleOk() {
      this.pagination.current = 1;
      this.palnShow = false;
      this.$message.success(this.$t('保存成功'));
      // this.getDataFun();
    },
    handleDelete(i, record) {
      let _this = this;
      if (record.status == 1) {
        return this.$message.warn(this.$t('请禁用方案后删除'));
      }
      this.$confirm({
        title: this.$t('是否确认删除该产品方案') + '？',
        okText: this.$t('确定'),
        async onOk() {
          if (record.mark) {
            _this.deletePlanId.push(record.id);
          }
          _this.data.splice(i, 1);
          _this.pagination.total = _this.data.length;
          _this.$message.success(_this.$t('操作成功') + '!');
          // _this.resetBudget();
          return;
        },
        onCancel() {}
      });
    },
    cancelBudget() {
      this.budgetVisible = false;
    },
    async resetBudget(key) {
      var _this$budget;
      if ((_this$budget = this.budget) !== null && _this$budget !== void 0 && (_this$budget = _this$budget.paramConfig) !== null && _this$budget !== void 0 && _this$budget.length) {
        await this.getDimensions();
      } else {
        this.formParams = [];
        // this.previewData = {};
      }
      if (key !== 'save') {
        for (let index = 0; index < this.data.length; index++) {
          const element = this.data[index];
          element.isDefault = 0;
        }
        if (this.budget.moneyInfo && this.budget.moneyInfo.length) {
          var _this$budget$moneyInf;
          this.budget.moneyInfo = (_this$budget$moneyInf = this.budget.moneyInfo) === null || _this$budget$moneyInf === void 0 ? void 0 : _this$budget$moneyInf.map(item => {
            item.selected = false;
            return item;
          });
        }
      }
      this.budget = this.budget;
      this.addStauts = false;
      this.editStauts = false;
      this.copyStauts = false;
      this.stateStatus = false;
      this.firstIsEdit = false;
    },
    checkedFun(val) {
      if (!this.stateStatus && this.data.find(i => i.isDefault)) {
        let _this = this;
        this.$confirm({
          title: this.$t('禁用/启用数据将会清空保费试算的默认方案，需重新进行配置（未配置无法保存数据），是否继续操作') + '？',
          okText: this.$t('确定'),
          async onOk() {
            _this.resetBudget();
            val.status = val.status == 1 ? 0 : 1;
            _this.$message.success(_this.$t('修改成功') + '!');
            _this.stateStatus = true;
            return;
          },
          onCancel() {
            _this.stateStatus = true;
          }
        });
      } else {
        val.status = val.status == 1 ? 0 : 1;
        this.$message.success(this.$t('修改成功') + '!');
        this.resetBudget();
      }
      // planStatus({insurancePlanId: val.insurancePlanId, status: val.status == 1 ? 0 : 1}).then(res => {
      //   val.status = val.status == 1 ? 0 : 1;
      // });
    },
    async openComparison() {
      var _this$data2;
      (_this$data2 = this.data) === null || _this$data2 === void 0 || _this$data2.map(item => {
        let obj = {};
        if (item.status == 1) {
          obj = {
            id: item.id,
            name: item.name,
            rights: item.rights
          };
          return obj;
        }
      });
      let planInfo = this.data.filter(item => item.status == 1);
      let params = {
        insuranceId: this.id,
        info: planInfo
      };
      const res = await planContrast(params);
      this.comparisonList = res;
      this.comparisonVisible = true;
    },
    async onSavePlan() {
      let _this = this;
      if (!this.data.length) {
        this.$confirm({
          title: this.$t('当前产品未配置方案信息，可能会无法正常使用客户端（APP、H5）投保、后台录入保单等关联功能，是否继续保存数据') + '？',
          okText: this.$t('保存'),
          async onOk() {
            await _this.planPort();
            return;
          },
          onCancel() {}
        });
      } else if (!this.budget.paramConfig || !this.budget.paramConfig.length || !this.data.find(i => i.isDefault == 1)) {
        this.$confirm({
          title: this.$t('当前产品方案未配置保费试算参数，客户端（APP、H5）将无法进行投保，是否继续保存数据') + '？',
          okText: this.$t('保存'),
          async onOk() {
            await _this.planPort();
            return;
          },
          onCancel() {}
        });
      } else {
        await this.planPort();
      }
    },
    async planPort() {
      let budget = {};
      if (this.budget.paramConfig && this.budget.paramConfig.length) {
        budget.type = this.budget.type;
        budget.isOnlyAmount = false;
        budget.dimensions = recursionCopy(this.budget.paramConfig);
        budget.moneyInfo = this.budget.moneyInfo;
      } else {
        var _this$data3;
        let data = (_this$data3 = this.data) === null || _this$data3 === void 0 ? void 0 : _this$data3.map((item, i) => {
          item.isDefault = 0;
          return item;
        });
        this.data.splice(0);
        this.data.push(...data);
      }
      await addMainPlan({
        insuranceId: this.id,
        budget,
        data: this.data,
        deletePlanId: this.deletePlanId
      });
      this.$message.success(this.$t('操作成功') + '!');
      this.$router.push({
        name: 'insuranceManage'
      });
    },
    async configBudget() {
      var _this$data4;
      let data = [];
      (_this$data4 = this.data) === null || _this$data4 === void 0 || _this$data4.map(item => {
        var _item$tagsSort;
        if ((_item$tagsSort = item.tagsSort) !== null && _item$tagsSort !== void 0 && _item$tagsSort.length && item.tagsSort != '[]' && item.status == 1) {
          data.push(JSON.parse(item.tagsSort));
        }
      });
      let obj = data.length ? {
        tags: JSON.stringify(data)
      } : {
        tags: ''
      };
      obj.insuranceId = this.id;
      if (this.isComparison()) {
        const res = await planMarkResource(obj);
        this.paramsList = res;
        this.budgetVisible = true;
      } else {
        this.$message.warn(this.$t('暂无启用方案'));
      }
    },
    onSaveBudget(newParams) {
      var _this$data5;
      this.hasNewBudget = true;
      // this.budget.type = newParams.type;
      // this.budget.paramConfig = 0newParams.paramConfig;
      // this.budget.moneyInfo = newParams.moneyInfo;
      this.budget = newParams;
      (_this$data5 = this.data) === null || _this$data5 === void 0 || _this$data5.map((item, index) => {
        this.data[index].isDefault = 0;
      });
      if (this.budget.paramConfig && this.budget.paramConfig.length) {
        var _this$data6;
        (_this$data6 = this.data) === null || _this$data6 === void 0 || _this$data6.map((item, index) => {
          if (item.name == this.budget.moneyInfo.find(i => i.selected).name) {
            this.data[index].isDefault = 1;
          }
        });
        this.resetBudget('save');
      }
      // this.previewData = {};
      console.log(newParams, 'recordChangeParams');
    },
    getSaveTags(data) {
      this.tagList = data;
    },
    async getDimensions() {
      var _this$budget2;
      const res = await planArea({
        level: 2
      });
      if ((_this$budget2 = this.budget) !== null && _this$budget2 !== void 0 && (_this$budget2 = _this$budget2.paramConfig) !== null && _this$budget2 !== void 0 && _this$budget2.length) {
        var _this$budget$paramCon, _this$budget$paramCon2, _this$data7;
        this.formParams = (_this$budget$paramCon = this.budget.paramConfig) === null || _this$budget$paramCon === void 0 ? void 0 : _this$budget$paramCon.map(i => i.mark);
        let dimensions = (_this$budget$paramCon2 = this.budget.paramConfig) === null || _this$budget$paramCon2 === void 0 ? void 0 : _this$budget$paramCon2.map(item => {
          if (item.mark === 'age') {
            var _item$controlsValue;
            let value = '';
            (_item$controlsValue = item.controlsValue) === null || _item$controlsValue === void 0 || _item$controlsValue.map(values => {
              if (item.controlsDefaultType == values.type) {
                value = item.controlsDefaultValue + ' ' + values.name;
              }
            });
            let obj = {
              name: item.field,
              value
            };
            return obj;
          } else if (item.mark === 'areaPrice') {
            let obj = {};
            let value = '';
            res === null || res === void 0 || res.map(area => {
              if (item.controlsDefaultValue.includes(area.code)) {
                value += area.name;
                if (area.child && area.child.length) {
                  var _area$child;
                  (_area$child = area.child) === null || _area$child === void 0 || _area$child.map(area1 => {
                    if (item.controlsDefaultValue.includes(area1.code) && area1.code !== area.code) {
                      value += area1.name;
                    }
                  });
                }
              }
            });
            obj.name = item.field;
            obj.value = value;
            return obj;
          } else if (item.mark === 'paymentDeadline') {
            if (item.controlsDefaultType == '0' && item.controlsDefaultValue == 0) {
              let obj = {
                name: item.field,
                value: this.$t('趸交')
              };
              return obj;
            } else {
              let value = '';
              item.controlsValue.map(info => {
                if (info.value && item.controlsDefaultValue == info.value || info.name && item.controlsDefaultValue == info.name) {
                  value = info.name;
                }
                // return;
              });
              let obj = {
                name: item.field,
                value
              };
              return obj;
            }
          } else {
            var _item$controlsValue2;
            let value = '';
            (_item$controlsValue2 = item.controlsValue) === null || _item$controlsValue2 === void 0 || _item$controlsValue2.map(info => {
              if (info.value && item.controlsDefaultValue == info.value || info.name && item.controlsDefaultValue == info.name) {
                value = info.name;
              }
              // return;
            });
            let obj = {
              name: item.field,
              value
            };
            return obj;
          }
        });
        (_this$data7 = this.data) === null || _this$data7 === void 0 || _this$data7.map((item, index) => {
          var _this$budget$moneyInf2;
          let name = this.budget.moneyInfo && Array.isArray(this.budget.moneyInfo) && ((_this$budget$moneyInf2 = this.budget.moneyInfo.find(i => i.selected)) === null || _this$budget$moneyInf2 === void 0 ? void 0 : _this$budget$moneyInf2.name);
          if (item !== null && item !== void 0 && item.name && (item === null || item === void 0 ? void 0 : item.name) == name) {
            this.data[index].isDefault = 1;
          }
        });
        dimensions === null || dimensions === void 0 || dimensions.map(i => {
          var _this$data8;
          (_this$data8 = this.data) === null || _this$data8 === void 0 || _this$data8.map((item, index) => {
            var _this$budget$moneyInf3;
            let name = this.budget.moneyInfo && Array.isArray(this.budget.moneyInfo) && ((_this$budget$moneyInf3 = this.budget.moneyInfo.find(i => i.selected)) === null || _this$budget$moneyInf3 === void 0 ? void 0 : _this$budget$moneyInf3.name);
            if (item !== null && item !== void 0 && item.name && (item === null || item === void 0 ? void 0 : item.name) == name) {
              this.data[index].isDefault = 1;
            }
          });
        });
        let moneyInfo = recursionCopy(this.budget.moneyInfo);
        this.previewData = {
          dimensions,
          moneyInfo,
          type: this.budget.type
        };
        this.$refs.budgetRef.previewData = this.previewData;
      }
    }
  }
};